import {useState} from "react";
import {getColor} from "@/styles/ThemeConfig";
import {breakpoints} from "@/styles/sizes";
import styled, {css} from "styled-components";
import Image from "next/image";

import MinusWhiteIcon from '/public/images/minus_white.svg';
import PlusIcon from '/public/images/plus.svg';


const TitleWrapper = styled.div`
    color: ${getColor('gold')};
    text-transform: uppercase;
    text-align: center;
    @media only screen and (${breakpoints.mobile}) {
        padding: 0 10px;
        h2{
            font-size: 25px!important;

        }
    }
    margin-bottom: 30px;
`;


const FaqQuestion = styled.div`
    background: white;
    color: ${getColor('greenText')};
    font-family: 'Josefin Sans';
    font-size: 14px;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 20px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom:1px solid black;

    ${props => props.isActive && css`
        background: ${getColor('gold')}!important;
        color: white;
        border-bottom:none;
    `}

`;

const FaqAnswer = styled.div`
    color: ${getColor('greenText')};
    max-height: 0;
    padding: 0;
    overflow: hidden;
    transition: 0.5s ease; /* Only apply transition to max-height */

    ${props => props.isActive && css`
        max-height: 500px; /* Set a large enough max-height */
    `}

    .faq-answer { padding: 20px; }
`;



const ColumnWrapper = styled.div`
    display: flex;
    gap: 50px;
    @media only screen and (${breakpoints.mobile}) {
        flex-direction: column;
        padding: 20px;
        gap: 10px;
    }
`;

const ContentWrapper = styled.div`
    padding:80px 0;
    @media only screen and (${breakpoints.mobile}) {
        padding:0px 0;

    }
`;

export default function VariantBFaqSection({
    title,
    withMarginTop = true,
    faqs = []
})
{
    const [activeIndex, setActiveIndex] = useState(null);
    const half = Math.ceil(faqs.length / 2);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <ContentWrapper id={'FAQ'}>
            <div className={"container_small"} suppressHydrationWarning>
                <TitleWrapper>
                    <h2 className={'h3'} style={{fontWeight: 'bold'}}>{title ?? 'Frequently Asked Questions'}</h2>
                </TitleWrapper>
                <ColumnWrapper>
                    {/* First Column */}
                    <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: '0px'}}>
                        {faqs.slice(0, half).map((faq, index) => (
                            <div key={faq?.id ?? `${faq.question}-${index}`}>
                                <FaqQuestion isActive={activeIndex === index} onClick={() => toggleFAQ(index)}>
                                    <p>{faq.question}</p>
                                    {activeIndex === index ? (
                                        <Image src={MinusWhiteIcon} alt="-" />
                                    ) : (
                                        <Image src={PlusIcon} alt="+" />
                                    )}
                                </FaqQuestion>
                                <FaqAnswer isActive={activeIndex === index}>
                                    <div className="faq-answer" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                                </FaqAnswer>
                            </div>
                        ))}
                    </div>

                    {/* Second Column */}
                    <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: '0px'}}>
                        {faqs.slice(half).map((faq, index) => (
                            <div key={faq?.id ?? `${faq.question}-${index + half}`}>
                                <FaqQuestion
                                    isActive={activeIndex === index + half}
                                    onClick={() => toggleFAQ(index + half)}
                                >
                                    <p>{faq.question}</p>
                                    {activeIndex === index + half ? (
                                        <Image src={MinusWhiteIcon} alt="-" />
                                    ) : (
                                        <Image src={PlusIcon} alt="+" />
                                    )}
                                </FaqQuestion>
                                <FaqAnswer isActive={activeIndex === index + half}>
                                    <div className="faq-answer" dangerouslySetInnerHTML={{ __html: faq.answer }} />
                                </FaqAnswer>
                            </div>
                        ))}
                    </div>
                </ColumnWrapper>
            </div>
        </ContentWrapper>

    );
}
